<template>
  <button
      class="text-white bg-[#088dcd] uk-margin-small-right  font-bold   rounded-full focus:ring-4 focus:ring-primary-300   text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
  >
    <slot/>
  </button>
</template>
